module.exports = __webpack_public_path__ + "static/media/sad.30fe4fd3.png";